module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="heating-slider"><dl v-show="model.modelError"><dd><p class="error">ERROR! {{ model.modelError }}</p></dd></dl><label for="edit-heating">{{ tc(\'Switches\', \'Main Switch:\') }}</label><div id="edit-heating" class="input"><defa-radio-strip v-model="heatingSwitchValue" :options="heatingSwitchOptions" v-on:input="save($event, \'heatingSwitch\')" v-bind:class="{ errorState: model.heatingSwitch === null}"></defa-radio-strip><p v-show="model.heatingSwitchError" class="error">{{ model.heatingSwitchError }}</p></div></div>';
}
return __p;
};
